<template>
  <div
    :key="componentKey"
    class="card-pei"
    :class="{ 'not-allowed': disabled }"
    @click="clickItem"
  >
    <div :id="headingOne" class="card-header" @click="clickHeader">
      <div class="row">
        <div class="col-12">
          <div class="tag-badge-pei mb-0">
            <div
              :class="{ collapsed: !expanded }"
              class="btn collapsed no-border"
              @click="toggleIcon"
              data-toggle="collapse"
              :data-target="`#${collapseOne}`"
              :aria-expanded="expanded"
              :aria-controls="collapseOne"
            >
              <span class="dot-pei" :class="{
                    'error': error,
                    'dot-pei-white': checked && !error && !isOpen,
                    'dot-pei-black': (!checked || error) && !isOpen,
                    'dot-pei-orange': isOpen && !checked
                  }">
                <i
                  v-if="checked && !error"
                  class="fas fa-check-circle text-green"
                />
                <i
                  v-if="selected && !checked && !error && !isOpen"
                  class="fas fa-plus text-white"
                />
                <i
                  v-if="!checked && !selected && !error && !isOpen"
                  class="fas fa-plus text-white"
                />
                <i v-if="error && !isOpen" class="fas fa-plus icon-error" />
                <i v-if="isOpen && !checked" class="fas fa-minus text-white" />
              </span>
              <span class="title-pei">{{ title }}</span>
            </div>
          </div>
          <span v-if="!error" class="text-alert text-gray">{{ alert }}</span>
          <span v-if="error" class="text-alert text-error">
            {{ customErrorMsg }}
          </span>

          <div class="add-button float-right">
            <ActionButton
              v-if="buttonText"
              class="myi-0"
              :i="buttonIcon"
              :variant="buttonClass"
              :type="buttonType"
              :disabled="disabled"
              @click="onButtonClick"
            >
              {{ buttonText }}
            </ActionButton>
          </div>
          <div v-show="$slots['extraHeaderContent']" class="pt-2 float-right">
            <slot name="extraHeaderContent" />
          </div>
        </div>
      </div>
    </div>

    <div
      :ref="collapseOne"
      :id="collapseOne"
      class="collapse"
      :class="{ show: computedExpanded }"
      :aria-labelledby="headingOne"
      :data-parent="`#${parentId}`"
    >
      <div
        class="card-body shadow2"
        :style="{ 'background-color': bodyBackgroundColor }"
      >
        <slot />
        <div class="actions">
          <slot name="actions" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from '@/components/common/ActionButton';
export default {
  name: 'CustomCollapseItem',
  meta: {
    description: 'CustomCollapseItem, hijo del CustomCollapse',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  components: {
    ActionButton,
  },
  props: {
    componentKey: {
      type: Number,
      required: false,
      default: 0,
      meta: {
        description: 'Id contenedor',
        example: '14',
      },
    },
    parentId: {
      type: String,
      required: true,
      default: 'idCustomCollapse',
      meta: {
        description: 'Id del Componente padre',
        example: 'idCustomCollapse',
      },
    },
    title: {
      type: String,
      required: true,
      default: 'Header',
      meta: {
        description: 'Título del header',
        example: 'Texto Necesario',
      },
    },
    alert: {
      type: String,
      required: false,
      default: '',
      meta: {
        description: 'Mensaje después del header para notificaciones',
        example: 'Texto Necesario',
      },
    },
    checked: {
      type: Boolean,
      required: false,
      default: false,
      meta: {
        description: 'Cambia al estado checked',
        example: 'true',
      },
    },
    selected: {
      type: Boolean,
      required: false,
      default: false,
      meta: {
        description: 'Cambia al estado selected',
        example: 'true',
      },
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
      meta: {
        description: 'Estado que expande el contenedor',
        example: 'true',
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
      meta: {
        description: 'Estado Disabled',
        example: 'true',
      },
    },
    error: {
      type: Boolean,
      required: false,
      default: false,
      meta: {
        description: 'Estado Error',
        example: 'true',
      },
    },
    buttonIcon: {
      type: String,
      required: false,
      default: 'fas fa-file-plus',
      meta: {
        description: 'Icono del botón',
        example: 'Texto Necesario',
      },
    },
    buttonClass: {
      type: String,
      required: false,
      default: 'success m-2',
      meta: {
        description: 'Clases para el botón  ',
        example: 'Texto Necesario',
      },
    },
    buttonType: {
      type: String,
      required: false,
      default: '',
      meta: {
        description: 'Tipo del botón',
        example: 'Texto Necesario',
      },
    },
    buttonText: {
      type: String,
      required: false,
      default: '',
      meta: {
        description: 'Texto del boton',
        example: 'Texto Necesario',
      },
    },
    customErrorMsg: {
      type: String,
      required: false,
      default: 'Este campo debe ser completado.',
      meta: {
        description: 'Detalles del Error',
        example: 'Texto Necesario',
      },
    },
    bodyBackgroundColor: {
      type: String,
      default: '',
      meta: {
        description: 'Establece un Color de fondo del body',
        example: 'Texto Necesario',
      },
    },
  },
  computed: {
  computedExpanded() {
      return !this.disabled && this.expanded;
    },
    isOpen() {
      return this.computedExpanded;
    }
  },
  data: () => ({
    headingOne: null,
    collapseOne: null,
    isOpenByJs: false,
    isOpenByCss: false,
  }),
  methods: {
    clickItem: function(evt) {
      if (this.disabled) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
      }else{
      this.$emit('expandButtonClick', this.isOpen);
      }
    },
    clickHeader: function(evt) {
      if (this.disabled) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
      }else{
        evt.preventDefault();
        evt.stopImmediatePropagation();
      this.$emit('onClickHeader', this.isOpen);
      }
    },
    onButtonClick() {
      this.collapseAllAndExpandCurrent();
      this.$emit('collapseItemButtonClick');
    },
    collapseAllAndExpandCurrent() {
      let elements = document.querySelectorAll('[id*="collapse_"]');
      for (let i = 0; i < elements.length; i++) {
        if (elements[i].id != this.collapseOne) {
          if (elements[i].classList.contains('show'))
            elements[i].classList.remove('show');
        } else {
          if (!elements[i].classList.contains('show')) {
            elements[i].classList.add('show');
          }
        }
      }
    },
    toggleIcon() {
      if (this.disabled) return;

      // Emitimos un cambio al padre
      this.$emit('toggleCollapse');
    },
    observeOpenByCss() {
      const targetNode = this.$refs[this.collapseOne];
      const config = { attributes: true, attributeFilter: ['class'] };

      const callback = (mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            this.isOpenByCss = targetNode.classList.contains('show') && !this.isOpenByJs;
          }
        }
      };

      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config);

      // Initial check
      this.isOpenByCss = targetNode.classList.contains('show');
    }
  },
  mounted() {
    this.headingOne = `heading_${this._uid}`;
    this.collapseOne = `collapse_${this._uid}`;
    this.$nextTick(() => {
      this.observeOpenByCss();
    });
  },
  watch: {
    expanded(newVal) {
      // No hace falta manipular la clase
      // Solo marcamos como abierto visualmente
      this.isOpenByJs = newVal;
    },
  }
};
</script>

<style scoped>
.card-pei {
  width: 102.4%;
  background-color: #ffffff;
}
.tag-badge-pei {
  display: inline-flex;
  padding-right: 1em;

  cursor: pointer;
}
.dot-pei {
  width: 24px;
  height: 24px;
  line-height: 22px;
  border-radius: 50%;
  display: inline-block;
  box-shadow: 0px 3px 6px #00000029;
  text-align: center;
  outline: 2px solid #ffff;
}
.dot-pei-white{
  background: #ffffff 0% 0% no-repeat padding-box;
}
.dot-pei-black{
  background: #3f5b60 0% 0% no-repeat padding-box;
}
.dot-pei-orange{
  background: #ff7058 0% 0% no-repeat padding-box;
}
.dot-pei .fas {
  font-size: 14px;
}
.dot-pei .fas.fa-check-circle {
  font-size: 24px;
}
.dot-pei.error {
  background-color: #ff5b5c;
}
.dot-pei.error i.icon-error {
  color: white;
}
.title-pei {
  font-weight: 700;
  margin-left: 0.5rem;
}
.fa-xl {
  font-size: 1.5em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}
.shadow2 {
  box-shadow: 0px 8px 10px #e4e6e2 inset;
}
.card-body.shadow2 {
}
.no-border {
  border: none !important;
}
.orange-icon {
  color: #ff7058;
}
.text-alert {
  margin-left: 1rem;
  font: 400 16px/19px Lato;
  letter-spacing: 0;
}
.actions {
  display: flex;
  justify-content: flex-end;
}
.not-allowed,
.not-allowed .tag-badge-pei,
.not-allowed .tag-badge-pei .btn {
  cursor: not-allowed;
}
.fa-edit:before {
  font-size: 18px !important;
}

.icon-red {
  margin-top: 10px !important;
  font-size: 18px !important;
}

.float-right {
  float: right;
}
.add-button button {
  margin: 0 !important;
}
.card-header {
  border-bottom: none;
}
</style>
